import { useEffect } from 'react';
import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import ButtonBase from 'src/components/Button';
import ModalLayoutBase, { MobileModalType, ModalContent as ModalContentBase, ModalFooter as ModalFooterBase, ModalHeader } from 'src/components/ModalLayout';
import { closeModalAtom } from 'src/stores/modal/atoms';
import { screenWidth } from 'src/styles/screenSize';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { ModalNavButtonType, ModalType } from 'src/types/Modal';
import { pushEvent } from 'src/utils/event-gateway';
const ModalLayout = styled(ModalLayoutBase)`
  ${({
  theme
}) => theme.screenSize.breakpointUp(screenWidth.mobile)} {
    max-width: unset;
    width: 768px;
  }
`;
const ModalContent = styled(ModalContentBase)`
  padding: 0px;

  ${({
  theme
}) => theme.screenSize.mobile} {
    padding: 0px;
    padding-top: 8px;
  }
`;
const Section = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${({
  theme
}) => theme.screenSize.mobile} {
    flex-direction: column-reverse;
    justify-content: center;
  }
`;
const GuideImage = styled.img`
  width: 308px;
  height: 225px;
  flex-shrink: 0;
`;
const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;

  padding: 24px;
  padding-inline-start: 0px;

  ${({
  theme
}) => theme.screenSize.mobile} {
    padding: 0px 24px;
  }
`;
const Title = styled.p`
  font-weight: 700;
  font-size: 30px;
  line-height: 40px;
  color: ${({
  theme
}) => theme.color.contentBrightFixed};

  ${({
  theme
}) => theme.screenSize.mobile} {
    font-size: 28px;
    line-height: 36px;
  }
`;
const Description = styled.span`
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: ${({
  theme
}) => theme.color.content9};
  white-space: pre-line;

  ${({
  theme
}) => theme.screenSize.mobile} {
    font-size: 14px;
    line-height: 18px;
    color: ${({
  theme
}) => theme.color.content10};
  }
`;
const ModalFooter = styled(ModalFooterBase)`
  ${({
  theme
}) => theme.screenSize.breakpointUp(screenWidth.mobile)} {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
`;
const ConfirmButton = styled(ButtonBase)`
  ${({
  theme
}) => theme.screenSize.breakpointUp(screenWidth.mobile)} {
    width: fit-content;
    min-width: 95px;
    padding: 0 16px;
  }
`;
const EthnicityGuideModal = () => {
  const closeModal = useSetAtom(closeModalAtom);
  const {
    t
  } = useTranslation();
  const handleClose = () => {
    closeModal(ModalType.ETHNICITY_GUIDE);
  };
  const handleClickGotItButton = () => {
    pushEvent({
      eventType: EVENT_TYPE.SIGN_UP,
      eventName: EVENT_NAME.SIGNUP__CLICK_GOT_IT_ETHNICITY_LEARN_MORE,
      eventParams: {
        action_category: 'click',
        tab: 'signup',
        page: 'ethnicity_learn_more',
        target: 'got_it'
      }
    });
    handleClose();
  };
  useEffect(() => {
    pushEvent({
      eventType: EVENT_TYPE.SIGN_UP,
      eventName: EVENT_NAME.SIGNUP__IMPRESSION_ETHNICITY_LEARN_MORE,
      eventParams: {
        action_category: 'impression',
        tab: 'signup',
        page: 'ethnicity_learn_more',
        target: 'ethnicity_learn_more'
      }
    });
  }, []);
  return <ModalLayout mobileType={MobileModalType.SCREEN_MODAL} navButtonType={ModalNavButtonType.CLOSE} closeWhenClickOutside onClose={handleClose} data-testid='EthnicityGuideModal' isDim data-sentry-element="ModalLayout" data-sentry-component="EthnicityGuideModal" data-sentry-source-file="index.tsx">
      <ModalHeader data-sentry-element="ModalHeader" data-sentry-source-file="index.tsx" />
      <ModalContent data-sentry-element="ModalContent" data-sentry-source-file="index.tsx">
        <Section data-sentry-element="Section" data-sentry-source-file="index.tsx">
          <GuideImage src='/images/register/imgUSGlobal.png' alt='ethnicity-guide' data-sentry-element="GuideImage" data-sentry-source-file="index.tsx" />
          <SectionContent data-sentry-element="SectionContent" data-sentry-source-file="index.tsx">
            <Title data-sentry-element="Title" data-sentry-source-file="index.tsx">{t('ONBOARDING__ETHNICITY_EXPLANATION_TITLE_V2')}</Title>
            <Description data-sentry-element="Description" data-sentry-source-file="index.tsx">{t('ONBOARDING__ETHNICITY_EXPLANATION_DESC_V2')}</Description>
          </SectionContent>
        </Section>
      </ModalContent>
      <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="index.tsx">
        <ConfirmButton id='EthnicityGuideModal-Confirm' onClick={handleClickGotItButton} data-testid='EthnicityGuideModal-Confirm' data-sentry-element="ConfirmButton" data-sentry-source-file="index.tsx">
          {t('guidelines_button')}
        </ConfirmButton>
      </ModalFooter>
    </ModalLayout>;
};
export default EthnicityGuideModal;